import { COLORS } from '../../assets/theme/colors'

export const SettingsStyle = () => ({
  label: {
    width: '100%',
    paddingLeft: '5px',
    textAlign: 'left' as const,
    color: COLORS.darkerGray
  },
  labeledText: {
    height: '32px',
    width: '300px',
    textAlign: 'left' as const,
    paddingLeft: '10px',
    lineHeight: '32px'
  },
  messageBar: {
    root: {
      width: '1110px'
    }
  }
})
